import { RootState } from "app/store";
import SnapshotTimeline from "components/controls/SnapshotTimeline";
import { useSelector } from "react-redux";
import GroupConfigurationSnapshotContext from "../GroupConfigurationSnapshotContext";

const Timeline = () => {

    const state = useSelector((state: RootState) => state);

    return <GroupConfigurationSnapshotContext>
        <SnapshotTimeline snapshot={state.data.snapshot} />
    </GroupConfigurationSnapshotContext>;
}

export default Timeline;